import React, { useEffect, useCallback, useState } from 'react';
import { HStack, Spacer, Text } from 'native-base';
// import { useNavigation } from '@react-navigation/native';

// Assets & Icons
import {
  EmojiSadIcon as KickIcon,
  FlagIcon as ReportIcon,
} from 'react-native-heroicons/solid';
import { theme } from '@breakroom-nx/assets';

// Components
import { SecondaryButton, TertiaryButton, UserAvatar } from '../../';

// Classes & Types
import { RoomMember } from '@breakroom-nx/classes';

// Props
type Props = {
  member: RoomMember;
};

export const ChatMember = ({ member }: Props) => {
  const [loading, setLoading] = useState(false);

  return (
    <HStack py={3}>
      <HStack space={3} alignItems={'center'}>
        <UserAvatar
          noMargin
          uid={member.user.uid}
          key={member.user.uid}
          size={'40px'}
          flair={member.flair}
        />
        <Text fontWeight={600} fontSize={15} color={member.flair?.getColor()}>
          {member.user.username}
        </Text>
      </HStack>
      <Spacer />
      <HStack alignItems={'center'} space={2}>
        <SecondaryButton
          mini
          text="Vote to kick"
          disabled={loading}
          fontSize={14}
          color={theme.colors.primary[400]}
          onPress={() => {
            setLoading(true);
          }}
        />
        <TertiaryButton
          text="Report"
          mini
          fontSize={14}
          color={theme.colors.surface[500]}
          disabled={loading}
          onPress={() => {
            setLoading(true);
          }}
        />
      </HStack>
    </HStack>
  );
};
